import React, { Component } from "react";
import Home from "./components/home";

export default class App extends Component {
  state = {
    isLoggedIN: false,
  };

  static baseUrl = "https://virtual-e-guide.herokuapp.com/";
  static frontendBaseUrl = "https://e-virtual-guide.netlify.app/";

  render() {
    return <Home />;
  }
}
